@use '@design/design-tokens/typography/typography' as *;

.singleArticleRoot {
  display: flex;
  flex-direction: column;

  & > :last-child {
    margin-bottom: 0;
  }
}

.title {
  @include typography-v2-title-xl;
  margin-bottom: 8px;
}

.meta {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  display: flex;
  align-items: center;
  margin: 0;
}

.metaItem {
  &:not(:last-child)::after {
    content: '•';
    margin: 0 0.5em;
  }
}

.assetChips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
}

.contentSkeletonWrapper {
  padding: 16px 0;
}

.viewMoreButton {
  padding: 0 8px;
  border: none;
}
